import { HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
// import { environment } from '../../environments/environment.local';

export const api = environment.api;

export interface BaseFilter {
  limit?: number;
  skip?: number;
  ids?: string;
  sortField?: string;
  sortOrder?: string;
  query?: string;
  pricingGroupIds?: string;
}

export interface PaginatedResult<T> {
  data: T[];
  total: number;
}

const removeEmpty = (obj: BaseFilter): BaseFilter => {
  return Object.entries(obj)
    .filter(([_, v]) => v != null)
    .reduce((acc, [k, v]) => ({ ...acc, [k]: v === Object(v) ? removeEmpty(v) : v }), {});
};

export class HttpClientUtils {
  static toHttpParams(obj: BaseFilter): HttpParams {
    const clearedParams = removeEmpty(obj);

    return new HttpParams().appendAll({ ...clearedParams });
  }
}
